export default __webpack_public_path__ + "static/media/xero-logo.decd3f9d.png";